/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessUnitOverviewDtoSortingRequestDto } from './BusinessUnitOverviewDtoSortingRequestDto';
import {
    BusinessUnitOverviewDtoSortingRequestDtoFromJSON,
    BusinessUnitOverviewDtoSortingRequestDtoFromJSONTyped,
    BusinessUnitOverviewDtoSortingRequestDtoToJSON,
    BusinessUnitOverviewDtoSortingRequestDtoToJSONTyped,
} from './BusinessUnitOverviewDtoSortingRequestDto';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto
 */
export interface BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto {
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {BusinessUnitOverviewDtoSortingRequestDto}
     * @memberof BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto
     */
    sorting?: BusinessUnitOverviewDtoSortingRequestDto;
}

/**
 * Check if a given object implements the BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto interface.
 */
export function instanceOfBusinessUnitOverviewDtoFilterSortSearchPagedRequestDto(value: object): value is BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto {
    return true;
}

export function BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoFromJSON(json: any): BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto {
    return BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : BusinessUnitOverviewDtoSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoToJSON(json: any): BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto {
    return BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(json, false);
}

export function BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(value?: BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filters': FilterRequestDtoToJSON(value['filters']),
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': BusinessUnitOverviewDtoSortingRequestDtoToJSON(value['sorting']),
    };
}

